import React, { useEffect, useState, useRef } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { getLuzesStatusFlex35, statusDasLuzesFlex35} from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Ajuste o valor conforme necessário

  const groupRefs = useRef({
    grupo01: React.createRef(),
    grupo02: React.createRef(),
    grupo03: React.createRef(),
    grupo05: React.createRef(),
    grupo20: React.createRef(),
    grupo21: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo01: false,
    grupo02: false,
    grupo03: false,
    grupo05: false,
    grupo20: false,
    grupo21: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      console.log(`Status das luzes: ${statusDasLuzesFlex35}`);
      setLoading(false);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8000);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo01: statusDasLuzesFlex35.includes("1R10") && !statusDasLuzesFlex35.includes("1R00"),
      grupo02: statusDasLuzesFlex35.includes("1H10") && !statusDasLuzesFlex35.includes("1H00"),
      grupo03: statusDasLuzesFlex35.includes("1H10") && !statusDasLuzesFlex35.includes("1H00"),
      grupo05: statusDasLuzesFlex35.includes("1C10") && !statusDasLuzesFlex35.includes("1C00"),
      grupo20: statusDasLuzesFlex35.includes("1D10") && !statusDasLuzesFlex35.includes("1D00"),
      grupo21: statusDasLuzesFlex35.includes("1S10") && !statusDasLuzesFlex35.includes("1S00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };
  
  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  if (loading) {
    return null;
  }

  return (
    <div id="BotoesMobile">

      <h2 id='Title-botoes-Mobile'>Térreo</h2>
      {/* Botões para clicar em cima da legenda */}
      <div className="campoBotoesAcionamento-mobile">
        <div
          ref={groupRefs.current.grupo01}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo01', !imageStates.grupo01);
            sendCommandFlex35('Postes', imageStates.grupo01 ? '1A00' : '1A10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo01 ? 'Highlighted-mobile' : ''}`}>01</p>
          <p className="textBar-mobile">Postes</p>
        </div>

        <div
          ref={groupRefs.current.grupo02}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo02', !imageStates.grupo02);
            sendCommandFlex35('Muro acesso de Veículos', imageStates.grupo02 ? '1B00' : '1B10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo02 ? 'Highlighted-mobile' : ''}`}>02</p>
          <p className="textBar-mobile">Muro acesso de Veículos</p>
        </div>

        <div
          ref={groupRefs.current.grupo03}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo03', !imageStates.grupo03);
            sendCommandFlex35('Logo + Led Serviços', imageStates.grupo03 ? '1C00' : '1C10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo03 ? 'Highlighted-mobile' : ''}`}>03</p>
          <p className="textBar-mobile">Logo + Led Serviços</p>
        </div>
        <div
          ref={groupRefs.current.grupo05}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo05', !imageStates.grupo05);
            sendCommandFlex35('Iluminação Lixeira', imageStates.grupo05 ? '1E00' : '1E10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo05 ? 'Highlighted-mobile' : ''}`}>05</p>
          <p className="textBar-mobile">Iluminação Lixeira</p>
        </div>
        <div
          ref={groupRefs.current.grupo20}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo20', !imageStates.grupo20);
            sendCommandFlex35('Pendente Hall Social', imageStates.grupo20 ? '1N00' : '1N10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo20 ? 'Highlighted-mobile' : ''}`}>20</p>
          <p className="textBar-mobile">Pendente Hall Social</p>
        </div>
        <div
          ref={groupRefs.current.grupo21}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo21', !imageStates.grupo21);
            sendCommandFlex35('Hall Entrada Social', imageStates.grupo21 ? '1O00' : '1O10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo21 ? 'Highlighted-mobile' : ''}`}>21</p>
          <p className="textBar-mobile">Hall Entrada Social</p>
        </div>
      </div>
    </div>
  );
}

export default BotoesMobile;